import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl';

import BaseStudentActivityCard from '@ts-core/core/components/BaseStudentActivityCard';
import { formatDateTime } from '@ts-core/core/utils/dateFormatters';
import { formatScore } from '@ts-core/core/utils/scoreFormatters';

import { StudentAssignment } from '../../types';

interface StudentAssignmentCardProps {
  assignment?: StudentAssignment;
  loading?: boolean;

  onAssignmentClick?: (assignment: StudentAssignment) => void;
}

const StudentAssignmentCard = (props: StudentAssignmentCardProps) => {
  const { assignment, loading, onAssignmentClick } = props;
  const intl = useIntl();

  const handleSelectAssignment = useCallback(() => {
    if (assignment && onAssignmentClick) {
      onAssignmentClick(assignment);
    }
  }, [onAssignmentClick, assignment]);

  const actionTitle = useMemo(() => {
    if (!assignment) {
      return '';
    }
    if (assignment.expired || assignment.answered) {
      return intl.formatMessage({ id: 'generic.button.details' });
    }

    return intl.formatMessage({ id: 'studentAssignments.do' });
  }, [assignment, intl]);

  return (
    <BaseStudentActivityCard
      loading={loading}
      title={assignment?.name}
      subtitle={formatDateTime(assignment?.expirationDate)}
      score={formatScore(assignment?.answer?.score, assignment?.maxScore)}
      onActionClick={onAssignmentClick ? handleSelectAssignment : undefined}
      actionTitle={actionTitle}
    />
  );
};

export default StudentAssignmentCard;
